export default [
  {
    "_id": "5c520f11d3f5ea9de611a967",
    "index": 0,
    "guid": "5cc14c31-3bbe-4bf7-ac80-d19e9215d27f",
    "isActive": true,
    "balance": "$3,875.80",
    "age": 33,
    "eyeColor": "brown",
    "name": "Joanna Riggs",
    "gender": "female",
    "company": "ZILLACOM",
    "email": "joannariggs@zillacom.com",
    "phone": "+1 (890) 502-2390"
  },
  {
    "_id": "5c520f1171e5b12e31dbab1c",
    "index": 1,
    "guid": "1c0ef724-17d1-4ed6-b84c-3ba99fbdcd82",
    "isActive": true,
    "balance": "$3,200.93",
    "age": 35,
    "eyeColor": "brown",
    "name": "Marina Cohen",
    "gender": "female",
    "company": "DOGNOST",
    "email": "marinacohen@dognost.com",
    "phone": "+1 (881) 560-3033"
  },
  {
    "_id": "5c520f117892938e4677841d",
    "index": 2,
    "guid": "c05da5ae-5683-43f5-91b6-6d0b848099d6",
    "isActive": false,
    "balance": "$3,959.25",
    "age": 25,
    "eyeColor": "green",
    "name": "Reilly Roman",
    "gender": "male",
    "company": "NETROPIC",
    "email": "reillyroman@netropic.com",
    "phone": "+1 (804) 464-3429"
  },
  {
    "_id": "5c520f11161188a2656ae662",
    "index": 3,
    "guid": "aa697487-ba99-4c4c-857d-75646533d65f",
    "isActive": true,
    "balance": "$3,088.85",
    "age": 29,
    "eyeColor": "green",
    "name": "Erica Dejesus",
    "gender": "female",
    "company": "ISOTRACK",
    "email": "ericadejesus@isotrack.com",
    "phone": "+1 (915) 447-2295"
  },
  {
    "_id": "5c520f11b00ee8bedf42f4c3",
    "index": 4,
    "guid": "19d66d30-6fb3-4db4-a037-a7b36c439a56",
    "isActive": false,
    "balance": "$2,839.08",
    "age": 33,
    "eyeColor": "green",
    "name": "Georgia Nichols",
    "gender": "female",
    "company": "FLEXIGEN",
    "email": "georgianichols@flexigen.com",
    "phone": "+1 (845) 556-3229"
  },
  {
    "_id": "5c520f11a30bb3cefbd050f6",
    "index": 5,
    "guid": "35e5508a-b80f-4365-8fa2-3aebe4d5cf5f",
    "isActive": true,
    "balance": "$3,017.33",
    "age": 32,
    "eyeColor": "green",
    "name": "Porter Nunez",
    "gender": "male",
    "company": "ORBALIX",
    "email": "porternunez@orbalix.com",
    "phone": "+1 (972) 407-2732"
  },
  {
    "_id": "5c520f11244e501256f0eec0",
    "index": 6,
    "guid": "14b3aa67-c575-4f84-912f-b95ced97e38d",
    "isActive": false,
    "balance": "$3,858.47",
    "age": 37,
    "eyeColor": "blue",
    "name": "Clare Carver",
    "gender": "female",
    "company": "TURNABOUT",
    "email": "clarecarver@turnabout.com",
    "phone": "+1 (989) 481-2817"
  },
  {
    "_id": "5c520f111e46039d6c8ca366",
    "index": 7,
    "guid": "569615c2-cbdb-4bd7-82f8-016152cd7369",
    "isActive": false,
    "balance": "$3,357.49",
    "age": 40,
    "eyeColor": "blue",
    "name": "Gwen Tillman",
    "gender": "female",
    "company": "FUTURIZE",
    "email": "gwentillman@futurize.com",
    "phone": "+1 (800) 542-3687"
  },
  {
    "_id": "5c520f11f374748184411a79",
    "index": 8,
    "guid": "70a25db0-692d-485e-afbb-7bfc341b96fc",
    "isActive": false,
    "balance": "$3,125.10",
    "age": 25,
    "eyeColor": "brown",
    "name": "Rush Navarro",
    "gender": "male",
    "company": "EVENTEX",
    "email": "rushnavarro@eventex.com",
    "phone": "+1 (984) 494-2233"
  },
  {
    "_id": "5c520f113525f4fc51451476",
    "index": 9,
    "guid": "e7abf2c4-500b-4fcf-9f5a-e33c07e5233c",
    "isActive": true,
    "balance": "$1,876.28",
    "age": 32,
    "eyeColor": "brown",
    "name": "Blackwell Frost",
    "gender": "male",
    "company": "GOLOGY",
    "email": "blackwellfrost@gology.com",
    "phone": "+1 (905) 413-3127"
  }
]